import {AnyLinkType} from 'shared/pretty-easy-navigation/models';

export const TrainerMenu: AnyLinkType[] = [
    {
        type: 'link',
        label: 'navigation.dashboard',
        link: '/home',
    },
    {
        type: 'accordionLinkGroup',
        label: 'navigation.monitoring_group',
        links: [
            {
                type: 'link',
                label: 'navigation.groups_management',
                link: '/groups/list/groups',
            },
            {
                type: 'link',
                label: 'navigation.workgroups_management',
                link: '/groups/list/workgroups',
            },
            {
                type: 'link',
                label: 'navigation.learners_management',
                link: '/groups/list/learners',
            },
        ],
    },
    {
        type: 'accordionLinkGroup',
        label: 'navigation.lessons_group',
        links: [
            {
                type: 'link',
                label: 'navigation.models_lessons',
                link: '/lessons/list/models',
            },
            {
                type: 'link',
                label: 'navigation.user_lessons',
                link: '/lessons/list/user-lessons',
            },
        ],
    },
    {
        type: 'link',
        label: 'navigation.recommandations',
        link: '/page/recommendations',
    },
    {
        type: 'link',
        label: 'navigation.monitoring',
        link: '/page/followed',
    },
    {
        type: 'link',
        label: 'navigation.progress',
        link: '/page/results',
    },
    {
        type: 'link',
        label: 'navigation.feedback',
        link: '/feedback',
    },
    {
        type: 'link',
        label: 'navigation.legal_notice',
        link: '/informations-legales',
    },
    {
        type: 'link',
        label: 'navigation.site_map',
        link: '/page/site-map',
    }
];
